import { render, staticRenderFns } from "./MessageThread.vue?vue&type=template&id=38b3e0e0"
import script from "./MessageThread.vue?vue&type=script&lang=js"
export * from "./MessageThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports